// Simple localization utility
import ru from './ru';

const translations = {
  ru,
};

// Current language (for now hardcoded to Russian)
const currentLang = 'ru';

export function t(key) {
  return translations[currentLang][key] || key;
}
